import { EVENT_VIEW_CART_RECOMMENDATIONS } from '~~/constants/googleTagManager';
import type { ViewCartRecommendations, EcommerceViewCartRecommendations } from '~~/types/integrations/tagManager/TagViewCartRecommendations';

export const buildViewCartRecommendationsTags = ({
  sourceSku,
  viewCartRecommendationItems,
}: {
  sourceSku: string;
  viewCartRecommendationItems: ViewCartRecommendations;
}) => ({
  event: EVENT_VIEW_CART_RECOMMENDATIONS,
  ecommerce: {
    detail: {
      source_id: sourceSku,
      items: viewCartRecommendationItems,
    },
  } as EcommerceViewCartRecommendations,
});
